import { Mail, Phone, MessageSquare, MapPin, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const CONTACT = {
  email: "dicemaritime@gmail.com",
  phoneDisplay: "+971 50 442 4894",
  phoneRaw: "+971504424894",
  whatsapp: "https://wa.me/971504424894",
  address: "Jumeirah Bay Tower X2, Cluster X, Jumeirah Lake Towers, Dubai, U.A.E",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Jumeirah+Bay+Tower+X2+Cluster+X+Jumeirah+Lake+Towers+Dubai",
};

const CARDS = [
  { icon: Mail, label: "Email the Desk", value: CONTACT.email, href: `mailto:${CONTACT.email}`, testId: "contact-email-link", external: false },
  { icon: Phone, label: "Call Direct", value: CONTACT.phoneDisplay, href: `tel:${CONTACT.phoneRaw}`, testId: "contact-call-link", external: false },
  { icon: MessageSquare, label: "WhatsApp", value: CONTACT.phoneDisplay, href: CONTACT.whatsapp, testId: "contact-whatsapp-link", external: true },
  { icon: MapPin, label: "Visit the Office", value: "Jumeirah Bay Tower X2, JLT, Dubai", href: CONTACT.mapsUrl, testId: "contact-office-map-link", external: true },
];

export default function ContactCards() {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="contact-channels-grid">
      {CARDS.map((card, i) => (
        <Reveal key={card.label} delay={i * 0.08}>
          <a
            data-testid={card.testId}
            href={card.href}
            {...(card.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            className="group flex h-full flex-col justify-between border border-[#1E3A6E]/60 bg-[#091B3E]/70 p-7 backdrop-blur-xl transition-all duration-300 hover:-translate-y-1.5 hover:border-[#C5A059]/60 hover:shadow-[0_10px_30px_rgba(197,160,89,0.12)]"
          >
            <div className="flex items-start justify-between">
              <card.icon className="h-6 w-6 text-[#C5A059]" strokeWidth={1.5} />
              <ArrowUpRight className="h-4 w-4 text-slate-500 transition-colors duration-300 group-hover:text-[#C5A059]" />
            </div>
            <div className="mt-10">
              <p className="font-mono text-[0.65rem] uppercase tracking-[0.3em] text-slate-400">{card.label}</p>
              <p className="mt-2 break-words text-base font-medium text-white">{card.value}</p>
            </div>
          </a>
        </Reveal>
      ))}
    </div>
  );
}
